import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ListsCommonRepository } from './repository/lists-common.repository';

@NgModule({
  imports: [CommonModule],
  providers: [ListsCommonRepository]
})
export class ListsCommonModule {}
